(ns ui.editor2.sidebar-mention
  (:require [clojure.string :as str]
            [storrito.editor.sticker-design :as sticker-design]
            [ui.editor2.common :as common]))

(defn mention-edit-sidebar
  [state]
  [:div
   {:class ["flex" "flex-col" "gap-2" "w-full"]}

   (common/invisible-design-section
     {:design sticker-design/invisible-tag-design
      :text "@INVISIBLE"})

   [:div
    {:class ["flex" "items-center" "justify-between" "w-full"]}
    [:span
     {:class ["text-xs" "font-medium"]}
     "Designs"]]

   [:ul.grid.grid-cols-1.gap-6.lg:grid-cols-1
    (map
      (fn [design]
        (let [text-props (:text-props design)]
          [:li.col-span-1.rounded-lg.shadow.divide-y.divide-gray-200
           {:style {:background-color (or (:bg-color design)
                                          "#ffffff")}}
           [:button.w-full.flex.items-center.justify-center.rounded-md.p-2
            {:type "button"
             :on {:click [[:editor2/set-asset-design design]
                          [:editor2/prepare-assets!]]}}

            [:span
             {:style (merge {:fontSize "30px"
                             :fontFamily (:fontFamily text-props
                                           "AvenyT")
                             :color (:fill text-props)
                             :opacity (:opacity design)}
                            (when (:gradient design)
                              (let [color-string (str/join "," (vals (:gradient design)))]
                                {:-webkit-background-clip "text"
                                 :-webkit-text-fill-color "transparent"
                                 :background-image (str "linear-gradient(90deg, " color-string ")")})))}
             "@MENTION"
             ]]]))
      (concat
        sticker-design/all-new-designs
        (vals sticker-design/designs)))
    ]])
